import "./PCPSideBar.scss";
import "./PCPSideBarMobile.scss";
import activeArrow from "../../../Assets/Icons/active-arrow-icon.png";
import defaultProf from "../../../Assets/Icons/default-profile-pic.png";
import { useState } from "react";
import { FaArrowRight, FaChevronRight } from "react-icons/fa";

function PCPSideBar({
  items = [],
  active,
  activeMainNavId,
  onSelect,
  statusCountListById,
  setStatusCountListById,
  setOrderListUpdate,
  setCountListUpdateById,
  customerProvider,
}) {
  // ✅ Use array instead of object

  const [isOpen, setIsOpen] = useState(false); // 🔥 slide toggle
  const countMap = {
    UNPAID: statusCountListById.unpaidCount || 0,
    "PENDING APPROVAL": statusCountListById.pendingCount || 0,
    "PARTIALLY PAID": statusCountListById.partialCount || 0,
    "FULLY PAID": statusCountListById.paidCount || 0, // ✅ removed trailing space
    "TO RECEIVE": statusCountListById.toReceivedCount || 0,
    COMPLETED: statusCountListById.completedCount || 0,
    CANCELLED: statusCountListById.cancelledCount || 0,
    DECLINED: statusCountListById.declinedCount || 0,
    REFUNDED: statusCountListById.refundedCount || 0,
  };

  // //console.log("countMap:", countMap);
  const itemNames = [
    "unpaid",
    "pending",
    "partial",
    "fully",
    "toreceived",
    "completed",
    "cancelled",
    "declined",
    "refunded",
  ];
  return (
    <>
      {/* 🔥 Overlay background */}
      {isOpen && (
        <div className="psb-overlay" onClick={() => setIsOpen(false)} />
      )}

      <button
        className={`psb-toggle ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <FaChevronRight />
      </button>

      <div className={`PSB-container ${isOpen ? "open" : ""}`}>
        {items.map((item, index) => (
          <div
            key={item.id}
            className={`PSB-Nav-Item ${active === item.id ? "active" : ""}`}
            onClick={() => {
              onSelect(item.id);
              setOrderListUpdate(true);
              setCountListUpdateById((p) => !p);
            }}
          >
            <span>{item.name}</span>

            {activeMainNavId === "orders" && (
              <div className={`count ${itemNames[index]}`}>
                {countMap[item.name.toUpperCase()] ?? 0}
              </div>
            )}

            {active === item.id && <img src={activeArrow} alt="Active" />}
          </div>
        ))}
      </div>
    </>
  );
}

export default PCPSideBar;
